<template>
  <div>
    <!--遮罩-->
    <div class="showImg" @click="yinImg" v-if="showImg">
      <img @click="yinImg" :src="urlSrc" alt="#" />
    </div>
    <!--企业荣誉-->
    <Row
      justify="center"
      type="flex"
      style="background-color: white; padding-top: 40px"
    >
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <div style="display: flex">
          <div style="width: 3px; height: 32px; background-color: #337ab7">
            |
          </div>
          <div
            style="
              color: #498ad4;
              font-size: 24px;
              font-family: 微软雅黑, serif;
              margin: 0 0 0 14px;
            "
          >
            企业荣誉
          </div>
        </div>
      </Col>
    </Row>
    <Row justify="center" type="flex" style="background-color: white">
      <Col :xs="22" :sm="22" :lg="15" :xl="15">
        <Row justify="center" type="flex">
          <Col
            :xs="24"
            :sm="24"
            :lg="16"
            :xl="16"
            class="col_jian_01"
            v-for="(item, index) in imgPatent"
            :key="index"
          >
            <div class="col_div_00">
              <img
                style="width: 94%; height: 410px"
                :src="item.url"
                @click="getShowImg(item.url)"
                alt="#"
              />
            </div>
            <div class="colo_div_span">
              <span>{{ item.explain }}</span>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
    <!--企业专利-->
    <Row
      justify="center"
      type="flex"
      style="background-color: white; padding-top: 40px"
    >
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <div style="display: flex">
          <div style="width: 3px; height: 32px; background-color: #337ab7">
            |
          </div>
          <div
            style="
              color: #498ad4;
              font-size: 24px;
              font-family: 微软雅黑, serif;
              margin: 0 0 0 14px;
            "
          >
            企业专利
          </div>
        </div>
      </Col>
    </Row>
    <Row justify="center" type="flex" style="background-color: white">
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <Row justify="center" type="flex">
          <Col
            :xs="12"
            :sm="12"
            :lg="6"
            :xl="6"
            class="col_jian_01"
            v-for="(item, index) in imgPatentOne"
            :key="index"
          >
            <div class="col_div_01">
              <img
                style="width: 220px; height: 290px"
                :src="item.url"
                @click="getShowImg(item.url)"
                alt="#"
              />
            </div>
            <div class="colo_div_span">
              <span>{{ item.explain }}</span>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
    <!--企业软著-->
    <Row
      justify="center"
      type="flex"
      style="background-color: white; padding-top: 40px"
    >
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <div style="display: flex">
          <div style="width: 3px; height: 32px; background-color: #337ab7">
            |
          </div>
          <div
            style="
              color: #498ad4;
              font-size: 24px;
              font-family: 微软雅黑, serif;
              margin: 0 0 0 14px;
            "
          >
            企业软著
          </div>
        </div>
      </Col>
    </Row>
    <Row justify="center" type="flex" style="background: white">
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <Row justify="center" type="flex">
          <Col
            :xs="12"
            :sm="12"
            :lg="6"
            :xl="6"
            class="col_jian_01"
            v-for="(item, index) in imgSrc"
            :key="index"
          >
            <div class="col_div_01">
              <img
                style="width: 220px; height: 290px"
                :src="item.url"
                @click="getShowImg(item.url)"
                alt="#"
              />
            </div>
            <div class="colo_div_span">
              <span>{{ item.explain }}</span>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "Enterprise",
  data() {
    return {
      showImg: false,
      urlSrc: "",
      imgPatent: [
        {
          url: "../../static/img/EnterPrise/PatentOne/patent01.jpg",
          explain: "高新技术企业证书",
        },
      ],
      imgPatentOne: [
        {
          url: "../../static/img/EnterPrise/PatentOne/re01.png",
          explain: "新型激光扫平仪",
        },
        {
          url: "../../static/img/EnterPrise/PatentOne/rule.png",
          explain: "新型靠尺",
        },
        {
          url: "../../static/img/EnterPrise/PatentOne/rule01.png",
          explain: "可拆卸智能靠尺",
        },
        {
          url: "../../static/img/EnterPrise/PatentOne/beton.jpg",
          explain: "智能混凝土回弹仪",
        },
        {
          url: "../../static/img/EnterPrise/PatentOne/saichi.png",
          explain: "数显楔形塞尺",
        },
      ],
      imgSrc: [
        {
          url: "../../static/img/EnterPrise/patent/AR虚拟质量样板APP软件V1.0.jpg",
          explain: "AR虚拟质量样板APP软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR三合一综合体验软件.jpg",
          explain: "VR三合一综合体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR地铁安全事故体验软件V1.0.jpg",
          explain: "VR地铁安全事故体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR安全体验馆软件V2.0.jpg",
          explain: "VR安全体验馆软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR工程事故体验软件1.0.jpg",
          explain: "VR工程事故体验软件1",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR工程事故体验软件著作权证书.jpg",
          explain: "VR工程事故体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR引江济淮工程体验软件V1.0.jpg",
          explain: "VR引江济淮工程体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR施工安全体验软件著作权证书.jpg",
          explain: "VR施工安全体验软件著作权证书",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR机械事故VR体验软件V1.0.jpg",
          explain: "VR机械事故VR体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR消防逃生体验软件V1.0.jpg",
          explain: "VR消防逃生体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR路桥工程事故体验软件.jpg",
          explain: "VR路桥工程事故体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/安全标志标识.jpg",
          explain: "安全标志标识",
        },
        {
          url: "../../static/img/EnterPrise/patent/安全隐患排查.jpg",
          explain: "安全隐患排查",
        },
        {
          url: "../../static/img/EnterPrise/patent/建筑工程AR二十三项质量样板APP软件.jpg",
          explain: "建筑工程AR二十三项质量样板APP软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/建筑工程AR质量样板著作权证书.jpg",
          explain: "建筑工程AR质量样板著作权证书",
        },
        {
          url: "../../static/img/EnterPrise/patent/建筑工程VR质量样板软件著作权证书.jpg",
          explain: "建筑工程VR质量样板软件著作权证书",
        },
        {
          url: "../../static/img/EnterPrise/patent/技能知识宝典软件V1.0.jpg",
          explain: "技能知识宝典软件",
        },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    /*遮罩*/
    getShowImg(url) {
      this.showImg = true;
      this.urlSrc = encodeURI(url);
    },
    /*隐藏遮罩层*/
    yinImg() {
      this.showImg = false;
    },
  },
};
</script>

<style scoped>
.col_jian_01 {
  cursor: pointer;
  background: white;
  border: 1px solid #e1e1e1;
  margin: 40px 0 20px 10px;
  box-shadow: 0 0 20px rgb(0 0 0 / 25%);
  border-radius: 10px;
}

.col_div_01 {
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.col_div_00 {
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.colo_div_span {
  color: #14bce8;
  text-align: center;
  margin: 6px 0 10px 0;
  font-size: 16px;
  overflow: hidden;
  left: 20px;
}

/*--------遮罩------------*/
.showImg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 99;
  text-align: center;
}

.showImg img {
  width: 36%;
  cursor: pointer;
}

/*------------------------*/
</style>



// WEBPACK FOOTER //
// src/components/Enterprise.vue